import { render } from "./AccountSetting.vue?vue&type=template&id=5d40419e"
import script from "./AccountSetting.vue?vue&type=script&lang=ts"
export * from "./AccountSetting.vue?vue&type=script&lang=ts"

import "./AccountSetting.vue?vue&type=style&index=0&id=5d40419e&lang=css"
script.render = render

export default script